export enum CustomerComparisonField {
  // Required properties for sync to the NSC Database
  FIRST_NAME = 'FIRST_NAME',
  LAST_NAME = 'LAST_NAME',
  EMAIL_PRIVATE = 'EMAIL_PRIVATE',

  // Optional properties for sync to the NSC Database
  MIDDLE_NAME = 'MIDDLE_NAME',
  SALUTATION = 'SALUTATION',
  NAME_INITIALS = 'NAME_INITIALS',
  TITLE = 'TITLE',
  CORRESPONDENCE_LANGUAGE = 'CORRESPONDENCE_LANGUAGE',
  SUFFIX = 'SUFFIX',
  EMAIL_BUSINESS = 'EMAIL_BUSINESS',
  PHONE_BUSINESS = 'PHONE_BUSINESS',
  PHONE_PRIVATE = 'PHONE_PRIVATE',
  MOBILE_BUSINESS = 'MOBILE_BUSINESS',
  MOBILE_PRIVATE = 'MOBILE_PRIVATE',
  BIRTHDATE = 'BIRTHDATE',
  PLACE_OF_BIRTH = 'PLACE_OF_BIRTH',
  MAIN_ADDRESS = 'MAIN_ADDRESS',
  PRIVATE_ADDRESS = 'PRIVATE_ADDRESS',
  BUSINESS_ADDRESS = 'BUSINESS_ADDRESS',
  VAT_GROUP = 'VAT_GROUP',
  IS_INSOLVENT = 'IS_INSOLVENT',
  NATIONAL_ID_1 = 'NATIONAL_ID_1',
  NATIONAL_ID_1_DOCUMENT_TYPE = 'NATIONAL_ID_1_DOCUMENT_TYPE',
  NATIONALITY = 'NATIONALITY',
  SELF_EMPLOYED = 'SELF_EMPLOYED',
  CUSTOMER_MAIN_TYPE = 'CUSTOMER_MAIN_TYPE',
  DESCRIPTION = 'DESCRIPTION',
  TAX_NUMBER = 'TAX_NUMBER',
  TAX_NUMBER_COUNTRY = 'TAX_NUMBER_COUNTRY',
}
